const addBodyClassForSeatmap = function(){
    const syosContainer = document.querySelector(".tn-syos");
    const $body = document.querySelector("body");

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // All seatmap classes
            const seatmapClasses = [
                'seatmap--zipper-hall',

                'seatmap--thayer-hall',

                'seatmap--kohl-balcony-north',
                'seatmap--kohl-balcony-south',
                'seatmap--kohl-balcony-east',
                'seatmap--kohl-balcony-west',
                'seatmap--kohl-choir',
                'seatmap--kohl-floor',
                'seatmap--kohl-orchestra-east',
                'seatmap--kohl-orchestra-west',
            ];
            $body.classList.remove(...seatmapClasses);

            // Zipper Hall
            // 
            // Check for seat ID within each seatmap layout
            if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"49949\"]") && mutation.type === "childList") {
                // If so then add body class, and remove other body classes
                $body.classList.add('seatmap--zipper-hall');
            }
            // Thayer Hall
            // 
            // Check for seat ID within each seatmap layout
            if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"51779\"]") && mutation.type === "childList") {
                // If so then add body class, and remove other body classes
                $body.classList.add('seatmap--thayer-hall');
            }

            // Kohl Hall
            if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"97476\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-balcony-north');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"104103\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-balcony-south');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"104755\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-balcony-west');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"104545\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-balcony-east');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"92578\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-choir');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"102175\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-floor');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"90577\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-orchestra-east');
            } else if (document.querySelector(".tn-syos-seat-map__seat[data-tn-seat-id=\"91531\"]") && mutation.type === "childList") {
                $body.classList.add('seatmap--kohl-orchestra-west');
            }
        });
    });
    observer.observe(syosContainer, {
        subtree: true,
        childList: true
    });
}

const isElementLoaded = async selector => {
    while ( document.querySelector(selector) === null) {
      await new Promise( resolve =>  requestAnimationFrame(resolve) )
    }
    return document.querySelector(selector);
  };

  isElementLoaded('.tn-syos').then((selector) => {
    addBodyClassForSeatmap();
  });
